/* Starqon hareket katmanı — dalga 21 (2026-09-27). Bütçe: yalnız transform/opacity · bir kez oynar · ilk ekran ve LCP öğesi
   animasyonsuz · kütüphane yok · prefers-reduced-motion'da hiç çalışmaz. CSS karşılığı: starqon-custom.css §103. */
(function () {
  var d = document;
  d.addEventListener('touchstart', function () {}, { passive: true }); /* iOS Safari :active basma durumunu ancak dokunma dinleyicisi varsa uygular */
  /* 0) Kart→ürün geçişi (2026-10-09): aynı ürün iki şeritteyse view-transition-name çakışır ve tarayıcı geçişi atlar
     ("Transition was skipped"). Sayfadan çıkarken her addan yalnız ekranda görünen ilk öğe kalır. */
  addEventListener('pageswap', function () {
    var seen = {};
    d.querySelectorAll('[style*="view-transition-name"]').forEach(function (el) {
      var n = el.style.viewTransitionName; if (!n || n === 'none') return;
      var r = el.getBoundingClientRect(), v = r.width > 0 && r.bottom > 0 && r.top < innerHeight, s = seen[n];
      if (!s) { seen[n] = { el: el, v: v }; return; }
      if (v && !s.v) { s.el.style.viewTransitionName = 'none'; seen[n] = { el: el, v: v }; } else el.style.viewTransitionName = 'none';
    });
  });
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && Shopify.designMode)) return;

  /* 1) Kaydırmada belirme: yalnız sayfa açıldığında ekranın ALTINDA kalan öğeler; aynı anda görünenler 70 ms arayla */
  var SEL = '#MainContent .grid__item:not(.product__media-item):not(.thumbnail-list__item), #MainContent .title-wrapper-with-link, #MainContent .title-wrapper, #MainContent .rich-text__blocks, #MainContent .product__description, #MainContent .starqon-trust__list li, #MainContent .starqon-benefits__list li, #MainContent .starqon-reveal';
  function reveal() {
    var vh = innerHeight, els = d.querySelectorAll(SEL), below = [];
    for (var i = 0; i < els.length; i++) { var r = els[i].getBoundingClientRect(); if (r.top > vh && r.height > 0) below.push(els[i]); }
    var io = new IntersectionObserver(function (es) {
      var k = 0;
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.setProperty('--sq-i', Math.min(k++, 5));
        e.target.classList.add('sq-in'); io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    below.forEach(function (el) { el.classList.add('sq-rv'); io.observe(el); });
  }
  d.readyState === 'loading' ? d.addEventListener('DOMContentLoaded', reveal) : reveal();

  /* 3) Kayan şerit: yalnız ekrandayken oynar (ekran dışında animasyon durur → pil/GPU harcamaz) */
  var mio = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-on', e.isIntersecting); }); });
  d.querySelectorAll('[data-sq-marquee]').forEach(function (m) { mio.observe(m); });

  /* 2) Sepet çekmecesi açılırken satırlar kademeli girer — yalnız açılış anında (adet değişiminde yeniden oynamaz) */
  var drawer = d.querySelector('cart-drawer'), acik = false;
  if (drawer) new MutationObserver(function () {
    var a = drawer.classList.contains('active');
    if (a && !acik) { drawer.classList.add('sq-acilis'); setTimeout(function () { drawer.classList.remove('sq-acilis'); }, 700); }
    acik = a; /* kendi sınıf değişimimiz yeniden tetiklemesin: yalnız kapalı→açık geçişinde oynar */
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
})();
